/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./TextAction',
	'./ElementStyleTextAction',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../content/dataPointActions/api/DataPointActionsProviderAPI',
	'../../../content/slotActions/api/SlotActionsProviderAPI',
	'../../../content/elementStyleActions/api/ElementStyleActionsProviderAPI'
], (TextAction, ElementStyleTextAction, APIFactory, DataPointActionsProviderAPI, SlotActionsProviderAPI, ElementStyleActionsProviderAPI) => {

	class TextActionProxy {

		constructor(options) {
			this.dashboard = options.dashboardAPI;
			const elementStyleActionEnabled = !this.dashboard.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'ElementStyleAction', 'disabled');
			options.elementStyleActionEnabled = elementStyleActionEnabled;
			this._legacyInstance = new TextAction(options);
			this._elementStyleInstance = elementStyleActionEnabled ? new ElementStyleTextAction(options) : null;
			const apis = [
				{
					implementation: this._legacyInstance,
					interface: 	DataPointActionsProviderAPI
				},
				{
					implementation: this._legacyInstance,
					interface: 	SlotActionsProviderAPI
				}
			];
			if (this._elementStyleInstance){
				apis.push({
					implementation: this._elementStyleInstance,
					interface: ElementStyleActionsProviderAPI
				});
			}
			this._api = APIFactory.createAPIFromSpec(apis);
		}

		getAPI() {
			return this._api;
		}

	}

	return TextActionProxy;
});
